(function (app) {
    "use strict";

    var InterviewAvailabilityController = function ($scope, $alert, InterviewViewService, InterviewDataService, InterviewAvailabilityForm) {
        var self = this;
        var viewService = InterviewViewService({});
        self.startDayOfWeek = 'MON';
        self.weekStartDate = getWeekStart(moment().startOf('day'), self.startDayOfWeek);
        self.form = new InterviewAvailabilityForm($scope);
        self.form.load();
        self.savedSlots = [];
        self.newSavedSlots = {};
        self.savingCopy = false;
        self.replicate_type = '';
        self.interview_window = 365;

        var onInit = function () {
            self.weeklyRange = {
                from: self.weekStartDate.clone(),
                to: self.weekStartDate.clone().add(6, 'd')
            };
            self.form.initCalender();

            InterviewV2API.getUserAvailabilitySlots(self.weekStartDate.toDate())
                .then(function (res) {
                    var newArray = self.savedSlots.concat(res.slots);
                    self.savedSlots = _.uniq(newArray, "id");
                    self.savedSlots = _.uniq(angular.copy(self.savedSlots), "start_time");
                    InterviewDataService.parseData(self.weekStartDate, self.savedSlots);
                    viewService.doNotSplit = true;
                    viewService.init(self.weekStartDate, true);
                    viewService.drawAll();
                    $scope.$digest();
                }).catch(function (err) {
                console.log(err, "err");
                $alert({
                    content: $filter("translate")("Error while copying process."),
                    placement: 'top',
                    type: 'danger',
                    show: true,
                    container: 'body',
                    templateUrl: "../modules/team_schedule/employer/settings/alerts/save_settings_alert/save_settings_alert.html",
                    duration: 3
                });
                $scope.$digest();
            });
        };

        self.$onInit = function () {
            onInit();
        };

        self.$onChanges = function (changesObj) {
            if (
                typeof (changesObj.brandId) !== 'undefined' &&
                !changesObj.brandId.isFirstChange() &&
                JSON.stringify(changesObj.brandId.currentValue) !== JSON.stringify(changesObj.brandId.previousValue) &&
                self.mode !== "RECRUITMENT_HUB"
            ) {
                onInit();
            }
        };

        self.$postLink = function () {
            // var containerWidth = $('.interview-calendar-container').width();
        };

        self.$onDestroy = function () {
            InterviewDataService.reset();
        };

        self.onWeekSelected = function (weekRange) {
            if (viewService && weekRange) {
                if (self.replicationDone) {
                    self.weeklyRange = weekRange;
                    self.end_date_value = moment(self.weeklyRange.from).add(52, 'w').format("MMMM DD, YYYY");
                    self.weekStartDate = getWeekStart(self.weeklyRange.from, self.startDayOfWeek);
                    viewService.destroy();
                    viewService.init(self.weekStartDate, true);
                    InterviewDataService.resetAvailabilities();
                    viewService.clearGridAvailabilities();
                    viewService.drawAll();
                } else {
                    self.weeklyRange = weekRange;
                    self.weekStartDate = weekRange.from;
                    var isDataFound = false;
                    var columnDateValueFormat = "YYYY-MM-DD";

                    // check to know if we have got User Availability Slots before.
                    // no need to get User Availability Slots for this week if data was exist before.
                    for (var c in InterviewDataService.flatData.schedules) {
                        var newWeekStartDate = moment(self.weekStartDate).format(columnDateValueFormat);
                        if (c === newWeekStartDate) {
                            isDataFound = true;
                            viewService.doNotSplit = true;
                            viewService.init(self.weekStartDate,true);
                            viewService.drawAll();
                            return;
                        }
                    }

                    if (!isDataFound) {
                        onInit();
                    }
                }
            }
        };

        self.updateReplicateType = function () {
            if (self.replicate_type === 'NEVER_ENDS') {
                delete self.interview_window;
            }
        };

        self.OnCopiedInterviewAvailableSlots = async function () {
            if (self.form.validator.validate()) {
                // - loop on week slots
                // - calculate number of weeks for that slot
                // - loop on the calculated weeks
                // - copy
                var savedSlots = self.getCopiedSlots();
                for (var c = 0; c < savedSlots.length; c++) {
                    if (self.replicate_type === 'ENDS_ON') {
                        var diff = moment.duration(moment(self.ends_on_value).diff(moment(savedSlots[c]['start_time'])));
                        self.copy_availability_weeks = Math.floor(diff.asWeeks());
                    } else if (self.replicate_type === 'NEVER_ENDS') {
                        self.copy_availability_weeks = 25;
                    }

                    for (var N = 1; N <= self.copy_availability_weeks; N++) {
                        var slot = savedSlots[c];
                        var newSlotStart = (moment(slot['start_time']).add('d', 7 * (N))).valueOf();
                        var newSlotEnd = (moment(slot['end_time']).add('d', 7 * (N))).valueOf();
                        var newSlot = {
                            id: "temp_" + N + '_' + Date.now(),
                            start_time: newSlotStart,
                            end_time: newSlotEnd,
                            day: moment(newSlotStart).startOf().valueOf(),
                            viewInfo: slot.viewInfo
                        };

                        if (self.replicate_type === 'NEVER_ENDS') {
                            newSlot.recurrence_mode = "NEVER_ENDS";
                        }

                        const selectedSlots = Object.values(InterviewDataService.flatData.slots);

                        const isAlreadySelected = selectedSlots.some(selectedSlot => {
                            const isExactMatch = moment(selectedSlot.start_time).isSame(moment(newSlot.start_time)) &&
                                moment(selectedSlot.end_time).isSame(moment(newSlot.end_time));

                            const isOverlapping = moment(newSlot.start_time).isBetween(selectedSlot.start_time, selectedSlot.end_time, null, '[)') ||
                                moment(newSlot.end_time).isBetween(selectedSlot.start_time, selectedSlot.end_time, null, '(]') ||
                                moment(selectedSlot.start_time).isBetween(newSlot.start_time, newSlot.end_time, null, '[)') ||
                                moment(selectedSlot.end_time).isBetween(newSlot.start_time, newSlot.end_time, null, '(]');

                            const isOldSlotInsideNew = moment(selectedSlot.start_time).isSameOrAfter(newSlot.start_time) &&
                                moment(selectedSlot.end_time).isSameOrBefore(newSlot.end_time);

                            const isNewSlotInsideOld = moment(newSlot.start_time).isSameOrAfter(selectedSlot.start_time) &&
                                moment(newSlot.end_time).isSameOrBefore(selectedSlot.end_time);

                            if (isOverlapping && !isExactMatch && isOldSlotInsideNew) {
                                InterviewDataService.deleteSlot(selectedSlot);
                            }

                            return isExactMatch || (isOverlapping && isNewSlotInsideOld);
                        });

                        if (!isAlreadySelected) {
                            InterviewDataService.addSlot(newSlot);
                        }
                    }
                    viewService.init((moment(self.weekStartDate).add('d', 7 * (N))), true);
                }

                InterviewDataService.resetAvailabilities();
                viewService.clearGridAvailabilities();
                viewService.drawGridAvailabilities();
                viewService.init((moment(self.weekStartDate)),true);
                viewService.drawAll();
                self.copy_availability_weeks = 1;
                self.replicationDone = true;
                self.replicate_type = '';
                self.replicateCheckBox = false;
                HNotifications.show({
                    title: $filter("translate")("Success"),
                    desc: $filter("translate")("copied successfully"),
                    icon: "fa-check-circle",
                    type: "success",
                    timeout: 3000
                });
            }
        };

        self.getCopiedSlots = function () {
            // take the current opened week selected solts.
            var slots = [];
            for (var s in InterviewDataService.flatData['slots']) {
                var slot = InterviewDataService.flatData['slots'][s];
                if (slot.day >= moment(self.weeklyRange.from).valueOf() && slot.day <= moment(self.weeklyRange.to).valueOf()) {
                    slots.push(slot);
                }
            }

            return slots;
        };

        self.setAllSavedSelectedSlots = async function () {
            var flatDataDaysSlots = Object.values(InterviewDataService.flatData['days']);

            var collectedSlots = [];
            flatDataDaysSlots.forEach(function (day) {
                if (Object.keys(day).length !== 0) {
                    var values = Object.values(day);
                    collectedSlots = collectedSlots.concat(values);
                }
            });

            // take the current opened week solts.
            var slots = [];
            for (var slot in collectedSlots) {
                if (collectedSlots[slot].day >= moment(self.weeklyRange.from).valueOf() && collectedSlots[slot].day <= moment(self.weeklyRange.to).valueOf()) {
                    slots.push({
                        start_time: Utils.getISODate(moment(collectedSlots[slot].start_time).utc()),
                        end_time: Utils.getISODate(moment(collectedSlots[slot].end_time).utc()),
                        id: collectedSlots[slot].id
                    });
                }
            }


            self.selectedSlots = _.uniq(slots, "start_time");
            // load user available and booked slots.
            try {
                const res = await InterviewV2API.getUserAvailabilitySlots(
                    moment(self.weekStartDate).toDate(),
                    moment(self.weekStartDate).add(7 * self.copy_availability_weeks + 1, 'd').toDate()
                );

                const newArray = [...self.savedSlots, ...res.slots];
                self.savedSlots = _.uniq(newArray, "id");

                const allSelectedSlots = [];

                self.selectedSlots.forEach(slot => {
                    if (self.replicate_type === 'ENDS_ON') {
                        const diff = moment.duration(moment(self.ends_on_value).diff(moment(slot['start_time'])));
                        self.copy_availability_weeks = Math.floor(diff.asWeeks());
                    } else if (self.replicate_type === 'NEVER_ENDS') {
                        self.copy_availability_weeks = 25;
                    }

                    for (let N = 0; N <= self.copy_availability_weeks; N++) {
                        const newSlotStart = moment(slot['start_time']).add(7 * N, 'd').valueOf();
                        const newSlotEnd = moment(slot['end_time']).add(7 * N, 'd').valueOf();

                        const newSlot = {
                            id: `temp_${N}_${Date.now()}`,
                            start_time: newSlotStart,
                            end_time: newSlotEnd,
                            day: moment(newSlotStart).startOf('day').valueOf(),
                            viewInfo: slot.viewInfo,
                            recurrence_mode: self.replicate_type === 'NEVER_ENDS' ? 'NEVER_ENDS' : undefined
                        };

                        const isAlreadySaved = self.checkIfAlreadySavedBefore(newSlot);
                        const isAlreadySelected = self.checkIfAlreadySelectedBefore(newSlot);

                        if (isAlreadySaved === -1 && isAlreadySelected === -1) {
                            allSelectedSlots.push(newSlot);
                            InterviewDataService.addSlot(newSlot);
                        }
                    }
                });

                let uniqueAllSelectedSlots = [...self.savedSlots, ...allSelectedSlots];
                uniqueAllSelectedSlots = _.uniq(angular.copy(uniqueAllSelectedSlots), "id");
                uniqueAllSelectedSlots = _.uniq(angular.copy(uniqueAllSelectedSlots), "start_time");
                self.savedSlots = uniqueAllSelectedSlots;

                const endDate = moment(self.weekStartDate).add(7 * self.copy_availability_weeks, 'd');
                InterviewDataService.parseData(endDate, self.savedSlots);
                viewService.init(endDate, true);

                return {code: "META_LOADED"};
            } catch (err) {
                console.error(err, "err");
                $alert({
                    content: $filter("translate")("Error while copying process."),
                    placement: 'top',
                    type: 'danger',
                    show: true,
                    container: 'body',
                    templateUrl: "../modules/team_schedule/employer/settings/alerts/save_settings_alert/save_settings_alert.html",
                    duration: 3
                });
                throw err;
            }
        };

        self.checkIfAlreadySavedBefore = function (newSlot) {
            var isAlreadySaved = self.savedSlots.findIndex(function (savedSlot) {
                return (
                    (moment(savedSlot.start_time) == moment(newSlot.start_time)) &&
                    (moment(savedSlot.end_time) == moment(newSlot.start_time))
                );
            });

            return isAlreadySaved;
        };

        self.checkIfAlreadySelectedBefore = function (newSlot) {
            var isAlreadySelected = self.selectedSlots.findIndex(function (selectedSlot) {
                return (
                    (moment(selectedSlot.start_time) == moment(newSlot.start_time)) &&
                    (moment(selectedSlot.end_time) == moment(newSlot.start_time))
                );
            });

            return isAlreadySelected;
        };

        self.discard = function () {
            InterviewDataService.parseData(self.weekStartDate, self.savedSlots, true);
            viewService.doNotSplit = true;
            viewService.init(self.weekStartDate, true);
            viewService.drawAll();
        };

        var prepareMyInterviewAvailabilityPayload = function () {
            var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            self.savedSlots = InterviewDataService.retrieveSlotsToSave();

            var payload = {
                slots: self.savedSlots,
                applied_timezone: timezone,
            };

            return payload;
        };

        self.save = function () {
            self.form.saving = true;

            self.form.save()
                .then(function (formData) {
                    var payload = prepareMyInterviewAvailabilityPayload();
                    InterviewV2API.updateUserAvailabilitySlotsV2(payload)
                        .then(function () {
                            HNotifications.show({
                                title: $filter("translate")("Success"),
                                desc: $filter("translate")("Your availability settings were updated successfully."),
                                icon: "fa-check-circle",
                                type: "success",
                                timeout: 3000
                            });
                        })
                        .catch(function (err) {
                            console.error(err);
                            HNotifications.show({
                                title: $filter("translate")("Error"),
                                desc: $filter("translate")("Error saving your availability settings."),
                                icon: "fa-times-circle",
                                type: "danger",
                                timeout: 3000
                            });
                        })
                        .finally(function () {
                            self.form.saving = false;
                            $scope.$digest();
                        });
                }, function () {
                    self.form.saving = false;
                    $scope.$digest();
                });
        };
    };

    var InterviewAvailabilityComponent = {
        bindings: {
            mode: '<'
        },
        templateUrl: '../modules/interview-v2/interview-availability/interview-availability.html',
        controller: [
            '$scope',
            '$alert',
            'InterviewViewService',
            'InterviewDataService',
            'InterviewAvailabilityForm',
            InterviewAvailabilityController
        ],
        controllerAs: 'component'
    };

    app.component('interviewAvailability', InterviewAvailabilityComponent);

})(angular.module('harriApp.interviewV2'));